import { useParams } from "react-router-dom";
import FormTicket from "./formulario";

export function TicketEditar() {
  const idticket = useParams();
  return (
    <>
      <div className="container-fluid mt-2">
        <FormTicket idticket={idticket.id} acao="Editar" />
      </div>
    </>
  );
} 